/*{ <style>
@import url("https://cdnjs.cloudflare.com/ajax/libs/jstree/3.2.1/themes/default/style.min.css");
@import url("https://cdnjs.cloudflare.com/ajax/libs/bootstrap-datepicker/1.9.0/css/bootstrap-datepicker.min.css");
</style> }*/
//<style src="static/css/custom-checkbox.css"></style>
import moment from 'moment';
import InputTag from 'vue-input-tag'
import HttpFactory from '@/mixins/http.factory';
import DatePicker from '@/components/date-picker/date-picker.vue';
import Multiselect from 'vue-multiselect'
export default {
	name:'create-issue',
	mixins:[HttpFactory],
	data () {
		return {
			htmlMessage:null,
			data:null,
			jiraProjects:[],
            jiraProjectData:{
                issueTypes:[],
				issueMetaData:[],
                usersList:[],
				issueFields:null,
				fieldsList:[],
                customFields:[]
            },
			showLabels:false,
            editor_description_Obj:null,
            createIssueData:{attachments:[],files:[],fields:[]},
		}
	},
	created(){
		this.init();
	},
	methods:{
		init(){
			let _self=this;
			modalClient = ZAFClient.init();
			parentClient=null;
			var count=0;
			modalClient.on('send_data_to_modal', (data) => {
				parentClient = modalClient.instance(data.parentClientGuid)
				_self.zendeskInfo=data;
				count++;
				if(count==1){
					_self.issueFields();
				}
			});
		},
		initDropzone(data){
			const _self=this;
			if(!data || !data.userInfo || !data.userInfo.uploadFiles)return;
			_self.fn().initDropzone('div.dropzone',data.credentials,'devops',function(error,response){
				if(error){
					_self.userMsg={show:true,type:'danger',list:[response?response:error]}
					return;
				}
				_self.createIssueData.files=_self.createIssueData.files.concat(response);
			});
		},
		removeFile(file){
			const _self=this;
			_self.createIssueData.files=_self.createIssueData.files.filter(d=>d.id!=file.id);
		},
		initCreateIssueData(data,project){
			let _self=this;
			_self.createIssueData.fields={};
			_self.createIssueData.hdTicketId=data.hdTicketId?data.hdTicketId:data.ticket.id;
			_self.createIssueData.fields['project']=project?project.name:'';
			_self.createIssueData.fields['summary']=data.ticket.subject;
			
			_self.createIssueData.fields['priority']=_self.handlePrioritySet(data.ticket.priority);
			_self.createIssueData.fields['fixVersions']='';
			_self.createIssueData.fields['components']='';
			_self.createIssueData.fields['assignee']='';
			_self.createIssueData.fields['reporter']='';

			_self.createIssueData.fields['issueType']='';
			_self.createIssueData.fields['labels']='';
			_self.createIssueData.fields['labelsArr'] =_self.createIssueData.fields['labels']?_self.createIssueData.fields['labels'].split(';'):[];
			_self.showLabels=true;

			//boolean

		},
		handlePrioritySet(priority){
			return (priority=='' || priority=='-')?'':this.fn().capitalizeFirstLetter(priority);
		},
		onDateChanged(date,el) {
			let _self = this;
			let referenceName=el.target.getAttribute('referenceName');
			_self.createIssueData.fields[referenceName]=date?_self.apiDateValue(date):null;

		},
		formatDateValue(date){
			if(!date) return null;
			return moment(date).format('MM/DD/YYYY');
		},
		apiDateValue(dateObj){
			let _self=this;
			let date=_self.formatDateValue(dateObj);
			//return date;
			if(!date) return null;
			
			var currentDate = new Date();
			var newDate= (new Date(`${date} `+currentDate.toLocaleTimeString()));
			newDate.setMinutes(newDate.getMinutes()+(currentDate.getTimezoneOffset()*-1));
			return newDate.toISOString();
			//return newDate;
		},
		async issueFields(){
			let _self=this;
			try{
				let data=null;
				let projectsResp=await _self.postServerFn(`jira/projects`,data);
				_self.htmlMessage=projectsResp.data.htmlMessage;
				let jiraProjects=projectsResp.data.Data.values;
				_self.jiraProjects=jiraProjects;
				if(jiraProjects && jiraProjects.length>0){
					_self.initCreateIssueData(_self.zendeskInfo,jiraProjects[0]);
					_self.createIssueData.project= jiraProjects[0];
				
					//issuetypes
					let issueTypesResp=await _self.postServerFn(`jira/issueTypes/${_self.createIssueData.project.id}`,data);
					_self.jiraProjectData=issueTypesResp.data.Data;
					_self.createIssueData.issueType=_self.jiraProjectData.issueTypes[0].name;
					_self.onIssueTypeChanged();
					_self.fn().showLoader(false);
					
					setTimeout(function(){_self.initDropzone(_self.zendeskInfo);},500);
					setTimeout(function(){
						let comments=_self.zendeskInfo.ticket.comments;
						if(comments){
							let description_html=comments && comments.length>0?comments[comments.length-1].value:_self.zendeskInfo.ticket.description;
							_self.fn().createHtmlEditor('editor_description','editor_description',description_html,function(editorObj,error){
								_self.editor_description_Obj=editorObj?editorObj:null;
							});
						}
					},1000);
					
				}
			}
			catch(ex){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the Jira does not have required permissions.',
					'Can you please create Jira token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000451379-how-to-create-azure-devops-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			}
		},
		// on project change
		onProjectChangeFn(cb){
			let _self=this;
			let project=_self.createIssueData.project;
			_self.initCreateIssueData(_self.zendeskInfo,project);
			_self.jiraIssueTypesDataFn(project.id,function(data){
				let jiraData=data.data.Data;
				_self.jiraProjectData=jiraData;
				_self.createIssueData.issueType=_self.jiraProjectData.issueTypes[0].name;
				_self.onIssueTypeChanged();
				if(cb) cb(jiraData);
				else{
					_self.fn().showLoader(false);
				}
			},function(err){
				_self.fn().showLoader(false);
				let erroList=[
					'We see your authentication token for the Jira does not have required permissions.',
					'Can you please create Jira token as per below article and update the app.',
					'https://support.devopsintegration.io/support/solutions/articles/82000451379-how-to-create-azure-devops-authentication-token-'
				]
				_self.userMsg={show:true,type:'danger',list:erroList};
			});
		},
		onIssueTypeChanged(){
			const _self=this;
			_self.jiraProjectData.issueFields=null;
			_self.jiraProjectData.fieldsList=[];
			_self.jiraProjectData.customFields=[];
			let issueType=_self.createIssueData.issueType;
			let fieldsList=_self.jiraProjectData.issueMetaData.projects.find(d=>d.id==_self.createIssueData.project.id);
			
			if(fieldsList){
				fieldsList=fieldsList.issuetypes.find(d=>d.name==issueType);
				if(fieldsList){
					_self.jiraProjectData.issueFields=fieldsList.fields;
					for(var key in fieldsList.fields){
						if(key.startsWith('customfield'))_self.jiraProjectData.customFields.push(fieldsList.fields[key]);
						else _self.jiraProjectData.fieldsList.push(fieldsList.fields[key]);
						
					}
				}
			}
		},
		isFieldRequired(fieldName,attrVal,astrik,prependExtra){
			const _self=this;
			prependExtra=prependExtra?prependExtra:'';
			let field=_self.jiraProjectData.issueFields[fieldName];
			let resp= attrVal?(field.required?'required':''):(astrik?(field.required?'*':''):field.required);
			return (prependExtra+resp);
		},
		initFieldsDefaultVal(fieldsList){
			const _self=this;
			let defaultValFields=fieldsList.filter(d=>d.defaultValue!==undefined || d.type=='boolean');
			if(defaultValFields){
				for(var i=0;i<defaultValFields.length;i++){
					if(defaultValFields[i].defaultValue){
						_self.createIssueData.fields[defaultValFields[i].referenceName]=defaultValFields[i].defaultValue;
					}
					else if(defaultValFields[i].type=='boolean'){
						_self.createIssueData.fields[defaultValFields[i].referenceName]=false;
					}
				}
			}

			let pickListFields=fieldsList.filter(d=>d.isPicklist || d.isIdentity);
			for(var i=0;i<pickListFields.length;i++){
				_self.createIssueData.fields[pickListFields[i].referenceName]=_self.createIssueData.fields[pickListFields[i].referenceName]?_self.createIssueData.fields[pickListFields[i].referenceName]:'';
			}
		},
		async validateForm(){
			let isValid=await this.$validator.validateAll();
			
			if(!isValid){
				this.userMsg={show:true,type:'danger',list:[`Please scroll up and fill all required fields.`]}
			}
			return isValid;
		},
		//create init
		jiraUsersFn:function(successCb,errorCb){
            var _self=this;
            var url = `jira/users`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
        jiraIssueTypesDataFn:function(projectId,successCb,errorCb){
            var _self=this;
            var url = `jira/issueTypes/${projectId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		jiraProjectDataFn:function(issueTypeId,successCb,errorCb){
            var _self=this;
            var url = `jira/projects/${issueTypeId}`;
            _self.fn().clearMessage();
			_self.postServerFn(url,null,successCb,errorCb);
        },
		createIssueFn(){
			let _self=this;
			_self.fn().clearMessage();
			if(_self.editor_description_Obj)
				_self.createIssueData.fields['System.Description']=_self.fn().getHtmlEditorContent(_self.editor_description_Obj);
			
			_self.createIssueData.fields['labels']=_self.createIssueData.fields['labelsArr']?_self.createIssueData.fields['labelsArr'].join(';'):'';
			let data={..._self.createIssueData};
			data.auth=_self.zendeskInfo.credentials;
			data.user=_self.zendeskInfo.user;
			delete data.fields['labelsArr'];
			let url=`jira/workitems/create`;
			_self.postServerFn(url,data,function(response){
				_self.fn().showLoader(false);
				let userMsg;
				if(response.data.Success){
					userMsg={show:true,type:'info',list:[response.data.Data?response.data.Data:`Work item created Successfully`]}
					_self.sendDataToParent(response.data);
				}else{
					_self.showLabels=false;
					_self.createIssueData.fields['labelsArr']=_self.createIssueData.fields['labels']?_self.createIssueData.fields['labels'].split(';'):[];
					setTimeout(function(){_self.showLabels=true;},1000);
					userMsg={show:true,type:'danger',list:[response.data.Data?response.data.Data:`Work item creation failed.`]}
				}
				_self.userMsg=userMsg;
			},function(error){ 
				_self.fn().showLoader(false);
				_self.showLabels=false;
				_self.createIssueData.fields['labelsArr']=_self.createIssueData.fields['labels']?_self.createIssueData.fields['labels'].split(';'):[];
				setTimeout(function(){_self.showLabels=true;},1000);
				_self.commonErrorMsgDisp(error);
			});
		},
		closeDialog(){
			modalClient.invoke('destroy');
		},
		sendDataToParent(data){
			parentClient.trigger('receive_data_from_modal', data)
      		modalClient.invoke('destroy');

		},
		postServerFn:async function(url,data,successCb){
			let _self=this;
			data=data?data:{};
			data.auth=_self.zendeskInfo.credentials;
			let response=await _self.post(url,data);
			if(successCb) successCb(response);
			else return response;
		}
	},
	components:{DatePicker,InputTag,Multiselect}
}

